import { Flex } from '@aloft/toolkit-sui';

type Props = React.PropsWithChildren;

export function MLSList({ children }: Props) {
  return (
    <Flex flexDirection="column" gap="6px">
      {children}
    </Flex>
  );
}
